<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle> <!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fal fa-draw-polygon" id="ico"></i>
		<h1 style="display: inline-block;">{{titulo}}</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<form [formGroup]="catForm" autocomplete="off">
			<div class="row">
				<div class="col-md-5">
					<mat-form-field class="example-full-width">
						<mat-label>Nombre </mat-label>
						<input matInput placeholder="Nombre" formControlName="nombre">
						<mat-error *ngIf="catForm.get('nombre').errors?.required">Campo Requerido</mat-error>
					</mat-form-field>
				</div>
                <div class="col-md-5">
                    <button class="btnPopup agregar mt-3" mat-raised-button [disabled]="catForm.invalid"
				(click)="agregarCategorias()" *ngIf="catForm.get('id').value == 0"><i id="btnIco" class="fas fa-plus"></i>&nbsp;Agregar</button>
                <button class="btnPopup agregar mt-3" mat-raised-button  [disabled]="catForm.invalid"
				(click)="actualizarCategoria()" *ngIf="catForm.get('id').value != 0"><i id="btnIco" class="fas fa-plus"></i>&nbsp;Actualizar</button>&nbsp;
				<kt-boton-exportar-tabla [tipoBoton]="'grid'" [nombreArchivo]="'Categorías Geocercas'" [datos]="datosReporte">
			</kt-boton-exportar-tabla>
                </div>
			</div>
		</form>
	</div>
</div>
<mat-divider class="mt-3"></mat-divider>
<div class="row mt-3"  style="margin-left: 4px;">
	<div  class="col-md-12">
		<mat-card>
			<div class="data-grid">
				<dx-data-grid id="gridContainer" [dataSource]="categoriasDataSource" [showBorders]="true">
					<dxo-paging [pageSize]="5"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]" [showInfo]="true">
					</dxo-pager>
					<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
                    <ng-container>
                        <dxi-column caption="Acciones" cellTemplate="Abrir" alignment="center" [width]="120">
                        </dxi-column>
                    </ng-container>
                    <div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
					<ng-container >
                        <dx-button valueExpr="id" id="actualizarButton" class="btnAcciones"
                            (click)="obtenerCategoriaId(d.data.id)">
                            <i class="fa fa-edit"></i>
                        </dx-button>
                    </ng-container>
                    <ng-container >
                        <dx-button valueExpr="id" id="deleteButton" class="btnAcciones"
                            (click)="eliminarCategoria(d.data.id)">
                            <i class="fa fa-trash"></i>
                        </dx-button>
                    </ng-container>
                </div>
					<dxi-column dataField="nombre" caption="Nombre" alignment="center">
						<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
					</dxi-column>
				</dx-data-grid>
			</div>
		</mat-card>
	</div>
</div>
<!--<mat-dialog-actions>
	<div class="float-right kt-form__actions kt-form__actions mt-3 offset-md-11">

	</div>
</mat-dialog-actions>-->
